import error from '../../../input/border-color/error';

export default error;
